import React from "react";
import { PiTranslateBold } from "react-icons/pi";
import { useLanguage } from "../../context/LanguageContext";

const AuthLayout = ({
  eyebrow,
  title,
  lead,
  illustration,
  footer,
  children,
  showAside = true,
  asideVariant = "image",
}) => {
  const { language, toggleLanguage, t } = useLanguage();
  const hasEyebrow = Boolean(eyebrow);
  const languageLabel = t(`auth.language.label.${language}`, language.toUpperCase());
  const languageToggleLabel =
    language === "en"
      ? t("auth.language.switchToGerman", "Switch to German")
      : t("auth.language.switchToEnglish", "Switch to English");
  const topClassName = `auth-card__top${hasEyebrow ? "" : " auth-card__top--solo"}`;
  const asideClassName = [
    "auth-card__aside",
    asideVariant !== "image" ? `auth-card__aside--${asideVariant}` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={`auth-page${showAside ? "" : " auth-page--minimal"}`}>
      <div className={`auth-card${showAside ? "" : " auth-card--minimal"}`}>
        <section className="auth-card__main">
          <div className={topClassName}>
            {hasEyebrow && <p className="auth-eyebrow">{eyebrow}</p>}
            <button
              type="button"
              className="auth-language-toggle"
              onClick={toggleLanguage}
              aria-label={languageToggleLabel}
            >
              <PiTranslateBold aria-hidden="true" />
              <span>{languageLabel}</span>
            </button>
          </div>
          <h1>{title}</h1>
          {lead && <p className="auth-lead">{lead}</p>}
          {children}
          {footer && <div className="auth-footer">{footer}</div>}
        </section>
        {showAside && (
          <aside className={asideClassName}>
            {illustration}
            <div className="auth-aside__overlay" />
          </aside>
        )}
      </div>
    </div>
  );
};

export const AuthField = ({ id, label, type = "text", endAdornment, ...props }) => (
  <label className="auth-field" htmlFor={id}>
    <span>{label}</span>
    {endAdornment ? (
      <div className="auth-field__input-wrapper">
        <input id={id} type={type} {...props} />
        {endAdornment}
      </div>
    ) : (
      <input id={id} type={type} {...props} />
    )}
  </label>
);

export default AuthLayout;
